import { render, staticRenderFns } from "./NvSelect.vue?vue&type=template&id=2b85a936&scoped=true&"
import script from "./NvSelect.ts?vue&type=script&lang=ts&"
export * from "./NvSelect.ts?vue&type=script&lang=ts&"
import style0 from "./NvSelect.vue?vue&type=style&index=0&id=2b85a936&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85a936",
  null
  
)

export default component.exports